/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteToolsetSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteToolsetSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteToolsetSecurity = {
  option1?: DeleteToolsetSecurityOption1 | undefined;
  option2?: DeleteToolsetSecurityOption2 | undefined;
};

export type DeleteToolsetRequest = {
  /**
   * The slug of the toolset
   */
  slug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteToolsetSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteToolsetSecurityOption1$outboundSchema: z.ZodMiniType<
  DeleteToolsetSecurityOption1$Outbound,
  DeleteToolsetSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteToolsetSecurityOption1ToJSON(
  deleteToolsetSecurityOption1: DeleteToolsetSecurityOption1,
): string {
  return JSON.stringify(
    DeleteToolsetSecurityOption1$outboundSchema.parse(
      deleteToolsetSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteToolsetSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteToolsetSecurityOption2$outboundSchema: z.ZodMiniType<
  DeleteToolsetSecurityOption2$Outbound,
  DeleteToolsetSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function deleteToolsetSecurityOption2ToJSON(
  deleteToolsetSecurityOption2: DeleteToolsetSecurityOption2,
): string {
  return JSON.stringify(
    DeleteToolsetSecurityOption2$outboundSchema.parse(
      deleteToolsetSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteToolsetSecurity$Outbound = {
  Option1?: DeleteToolsetSecurityOption1$Outbound | undefined;
  Option2?: DeleteToolsetSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteToolsetSecurity$outboundSchema: z.ZodMiniType<
  DeleteToolsetSecurity$Outbound,
  DeleteToolsetSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteToolsetSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteToolsetSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteToolsetSecurityToJSON(
  deleteToolsetSecurity: DeleteToolsetSecurity,
): string {
  return JSON.stringify(
    DeleteToolsetSecurity$outboundSchema.parse(deleteToolsetSecurity),
  );
}

/** @internal */
export type DeleteToolsetRequest$Outbound = {
  slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteToolsetRequest$outboundSchema: z.ZodMiniType<
  DeleteToolsetRequest$Outbound,
  DeleteToolsetRequest
> = z.pipe(
  z.object({
    slug: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteToolsetRequestToJSON(
  deleteToolsetRequest: DeleteToolsetRequest,
): string {
  return JSON.stringify(
    DeleteToolsetRequest$outboundSchema.parse(deleteToolsetRequest),
  );
}
